export default function scrollToElement(evt, element, scrollTop = 0, speed = 500, movingFrequency = 15) {
  function scrollToPos(i, hopTopPosition, initialScrollOffset) {
    setTimeout(() => {
      window.scrollTo(0, hopTopPosition + initialScrollOffset);
    }, movingFrequency * i);
  }

  if (evt) {
    evt.preventDefault();
  }

  if (element && typeof element.getBoundingClientRect === 'function') {
    const hopCount = speed / movingFrequency;
    const gap = element.getBoundingClientRect().top / hopCount;

    for (let i = 1; i <= hopCount; i++) {
      const hopTopPosition = gap * i;
      scrollToPos(i, hopTopPosition, scrollTop);
    }
  } else {
    throw new Error('no HTML element found');
  }
}



// WEBPACK FOOTER //
// ./src/util/scrollToElement.js